import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQueryWithReauth } from './authApi';

export const posCouponApi = createApi({
  reducerPath: 'posCouponApi',
  baseQuery: baseQueryWithReauth,
  endpoints: (builder) => ({

    // GET /api/v1/pos/coupons/validate?code=X&order_id=Y
    // Read-only preview — no side effects, usage count not incremented
    validateCoupon: builder.query({
      query: ({ code, order_id }) => ({
        url: '/coupons/validate',
        method: 'GET',
        params: { code: code.toUpperCase().trim(), order_id },
      }),
    }),

  }),
});

export const { useLazyValidateCouponQuery } = posCouponApi;
